import React from 'react'
import { Text } from '../../../../modules/Dashboard'
import { Link } from 'react-router-dom'

const NoPlanModal = ({ onClose }) => {
    return (
        <div className="p-4 flex flex-col items-center md:items-start gap-3">
            <div className='flex items-center gap-2'>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z" fill="#FF6900" fillOpacity="0.2" />
                    <path d="M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z" stroke="#FF8904" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M20 16V20" stroke="#FF8904" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M20 24H20.01" stroke="#FF8904" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <Text tid="no-plan-title" className='text-[#F3E8FF]' />
            </div>
            <div className='w-full flex flex-col gap-4 rounded-xl p-4 bg-[#59168B4D]'>
                <Text
                    tid="no-plan-desc"
                    className='text-[#DAB2FF] text-center md:text-start'
                />
            </div>
            <div className='w-full flex gap-2 items-center justify-end mt-4 '>
                <button
                    className="bg-[#59168B80] border border-[#AD46FF4D] px-3 py-2 rounded-lg  text-center w-full md:w-max"
                    onClick={onClose}
                >
                    <Text tid={"close"} className='text-[#E9D4FF]' />
                </button>

                <Link
                    className="bg-gradient-to-r from-[#9810FA] to-[#FF6900] px-3 py-2 rounded-lg text-center w-full md:w-max"
                    to={"/plans"}
                >
                    <Text tid={"view-plans"} />
                </Link>
            </div>
        </div>
    )
}

export default NoPlanModal
